import TopicTwo from "../../../components/platform-contents/meta-trader-5-contents/TopicTwo";

const MetaTrader5ContentFive = () => {
  return (
    <>
      {/* <TopicTwo /> */}

      <div className="how__work__platform">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Why Trade with MetaTrader 5 on The Pips</h1>
            <p>
              MT5 on The Pips delivers the perfect blend of innovation and
              reliability, giving traders the tools they need to perform with
              speed, accuracy, and confidence.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>More Markets, More Opportunities</h4>
                </div>
                <p>
                  With MT5’s multi-asset access, you can diversify and
                  capitalize on multiple market conditions, all from one unified
                  platform.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Built for Performance & Flexibility</h4>
                </div>
                <p>
                  MT5 supports algorithmic trading, hedging, and netting
                  systems, empowering you to tailor your experience to your
                  personal trading style.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Enhanced Transparency & Execution</h4>
                </div>
                <p>
                  Enjoy instant order execution, dynamic spreads, and full price
                  transparency with The Pips’ MT5 infrastructure, designed for
                  serious traders.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MetaTrader5ContentFive;
